module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/babel-runtime/core-js/get-iterator.js
 ** module id = 1494
 ** module chunks = 0
 **/